import React, { Fragment } from 'react';

import ItemPath from './info_panel.item_path.jsx';
import InputContainerWithInlineEditing from 'zoomforth_component_lib/input_container_with_inline_editing.jsx';
import TextInput from 'zoomforth_component_lib/basic_text_input.jsx';


const InfoPanelFolderUI = ({ 
  isDeletable,
  isMovable,
  isRenamable,
  isSpecialFolder,
  isInSearchMode,
  name,
  pathAsFolderData,
  onMoveClick,
  onDeleteClick,
  onFolderNavigate,
  onRenameSave

})=>
  <Fragment>
    <div className="preview-img"> 
      <div className="folder-preview-wrapper">
        {
          isSpecialFolder ?
          <img className="folder-preview" src="https://d3jozdooylvm2p.cloudfront.net/images/icons/media-folder_purp-large.png" />
        :
          <img className="folder-preview" src="https://d3jozdooylvm2p.cloudfront.net/images/icons/media-folder_blue-large.png" />
        }
      </div>
    </div>

    <div className="asset-info-area">
      <div className="asset-title">

        <InputContainerWithInlineEditing
          value={name || ''}
          editButtonText="Rename"
          getErrorMessageForValue={(value)=> value ? null : 'Must not be blank' }
          shouldRenderEditButton={false}
          onSave={onRenameSave}
          render={
            ({ value, isEditing, editButton, onValueChange, onSave })=>

              isEditing ?
                <TextInput 
                  tellRef={(ref) => { if (ref) { ref.focus(); } }}
                  value={value} 
                  onChange={(e) => onValueChange(e.target.value) }
                  onEnterKeyUp={onSave}
                />
              :
                <Fragment><span className="asset-title-text">{value}</span> {isRenamable ? editButton : null}</Fragment>
          }
        />

      </div>
      
    <div className="asset-details">
      { isInSearchMode &&
        <ItemPath 
          pathAsFolderData={pathAsFolderData} 
          onFolderNavigate={onFolderNavigate} 
        />
      }
      
      { isMovable &&
        <div className="move-asset action-move-item info-action-button" onClick={onMoveClick}> 
          <i className="fa fa-share"></i>
          Move
        </div>
      }
      { isDeletable &&
        <div className="delete-asset action-delete-item info-action-button" onClick={onDeleteClick}>
          <i className="fa fa-trash"></i>
          Delete
        </div>
      }
      </div>
    </div>
  </Fragment>;

export default InfoPanelFolderUI;
